import React, { Component } from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import LayoutContainer from '../components/LayoutContainer'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// core components
import GridContainer from '../components/Grid/GridContainer.jsx'
import GridItem from '../components/Grid/GridItem.jsx'
import Card from '../components/Card/Card.jsx'
import CardHeader from '../components/Card/CardHeader.jsx'
import AnchorPills from '../components/NavPills/AnchorPills'
import PostListing from '../components/PostListing/PostListing'
import {
  successColor,
  dangerColor,
  warningColor,
} from '../assets/jss/material-kit-pro-react'

import Ballot from '@material-ui/icons/Ballot'
import Dashboard from '@material-ui/icons/Dashboard'
import NewReleases from '@material-ui/icons/NewReleases'
import Bookmark from '@material-ui/icons/Bookmark'
import blogsStyle from '../assets/jss/material-kit-pro-react/views/sectionsSections/blogsStyle.jsx'

class Publications extends Component {
  getPublicationContext() {
    const categories = ['#knowledge', '#news', '#blog']
    const showFeaturedPost = !categories.includes(this.props.location.hash)
    return showFeaturedPost
  }
  getCategoryColor(category) {
    switch (category) {
      case 'knowledge':
        return successColor
      case 'news':
        return dangerColor
      case 'blog':
        return warningColor
    }
  }

  getTabs = () => {
    let tabs = [
      {
        tabButton: 'Recent',
        tabIcon: () => <Dashboard />,
        tabLink: '/publications',
      },
    ]

    const categories = this.props.data.allCategories.edges.map(
      edge => edge.node.frontmatter.category
    )

    if (categories.includes('knowledge')) {
      tabs.push({
        tabButton: 'Knowledge',
        tabIcon: () => <Ballot />,
        tabLink: '/categories/knowledge',
      })
    }
    if (categories.includes('news')) {
      tabs.push({
        tabButton: 'News',
        tabIcon: () => <NewReleases />,
        tabLink: '/categories/news',
      })
    }
    if (categories.includes('blog')) {
      tabs.push({
        tabButton: 'Blog',
        tabIcon: () => <Bookmark />,
        tabLink: '/categories/blog',
      })
    }
    return tabs
  }

  render() {
    const { classes, data } = this.props
    const featuredPost = data.allMarkdownRemark.edges[0].node
    const recentPosts = data.allMarkdownRemark.edges.slice(1)

    return (
      <LayoutContainer>
        <PublicationsContainer>
          <PublicationsTitle>Publications</PublicationsTitle>
          <PublicationsContainerInner>
            <AnchorPills color="primary" active={0} tabs={this.getTabs()} />
            {this.getPublicationContext() && (
              <Card plain blog className={classes.card}>
                <GridContainer alignItems="center">
                  <GridItem xs={12} sm={5} md={5}>
                    <CardHeader image plain>
                      <Link to={featuredPost.fields.slug}>
                        <Img
                          resolutions={
                            featuredPost.frontmatter.cover.childImageSharp
                              .resolutions
                          }
                          alt="..."
                        />
                      </Link>
                      <div
                        className={classes.coloredShadow}
                        style={{
                          backgroundImage: `url(${
                            featuredPost.frontmatter.cover.childImageSharp
                              .resolutions.base64
                          })`,
                          opacity: '1',
                        }}
                      />
                    </CardHeader>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <h6
                      style={{
                        color: this.getCategoryColor(
                          featuredPost.frontmatter.category
                        ),
                      }}
                      className={classes.cardCategory}
                    >
                      {featuredPost.frontmatter.category}
                    </h6>
                    <h3 className={classes.cardTitle}>
                      <Link to={featuredPost.fields.slug}>
                        {featuredPost.frontmatter.title}
                      </Link>
                    </h3>
                    <p className={classes.description1}>
                      {featuredPost.excerpt}
                      <Link to={featuredPost.fields.slug}> Read More </Link>
                    </p>
                    <small className={classes.author}>
                      <b>
                        {featuredPost.fields.parsedDate} &nbsp;&nbsp;&nbsp;
                        {featuredPost.timeToRead} min read
                      </b>
                    </small>
                  </GridItem>
                </GridContainer>
              </Card>
            )}
            <PostListing postEdges={recentPosts} />
          </PublicationsContainerInner>
        </PublicationsContainer>
      </LayoutContainer>
    )
  }
}

Publications.defaultProps = {
  active: 0,
  color: 'primary',
}

export const PublicationsContainer = styled.div`
  padding: ${p => p.theme.col(1.5)} ${p => p.theme.col(4)};
  padding-top: 0;

  @media screen and (max-width: 1440px) {
    max-width: 100vw;
    padding: 0 ${p => p.theme.col(2)} ${p => p.theme.col(1.5)};
  }

  @media screen and (max-width: 768px) {
    padding: 0 ${p => p.theme.col()};
    max-width: 100vw;
    overflow: hidden;

    .gatsby-image-wrapper {
      width: 100% !important;
    }
  }
`
export const PublicationsContainerInner = styled.div`
  padding: 0 ${p => p.theme.col()};
`
export const PublicationsTitle = styled.h2`
  margin: 4rem 0;

  @media screen and (max-width: 768px) {
    margin: 100px ${p => p.theme.col()} 0;
  }
`

export const publicationsQuery = graphql`
  query publicationsQuery {
    allMarkdownRemark(
      limit: 4
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { key: { eq: "publication" } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            cover {
              childImageSharp {
                resolutions(width: 435, height: 300) {
                  ...GatsbyImageSharpResolutions_withWebp
                }
              }
            }
            category
          }
        }
      }
    }
    allCategories: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "publication" } } }
    ) {
      edges {
        node {
          frontmatter {
            category
          }
        }
      }
    }
  }
`

export default withStyles(blogsStyle)(Publications)



// WEBPACK FOOTER //
// ./src/pages/publications.jsx